import { GameManager } from "../Managers/GameManager";
import { Scaling } from "./Scaling";

/**
 * @class CustomUtils
 */
export class CustomUtils {
    static isRespin(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0
        );
    }

    /**
     * Indicates that respin was triggered.
     * @returns {boolean}
     */
    static isRespinEnabled(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId === 0
        );
    }

    /**
     * Indicates that respin is in progress.
     * @returns {boolean}
     */
    static isRespinActive(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin !== 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    /**
     * Indicates that last respin round is in progress.
     * @returns {boolean}
     */
    static isRespinLast(): boolean {
        return (
            GameManager.baseResponse != null &&
            GameManager.baseResponse.respin != null &&
            GameManager.baseResponse.respin === 0 &&
            GameManager.baseResponse.spinId > 0
        );
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/